<template>
    <div class="gz-main-container">
        <GZ-Header/>
        <GZ-Content>
            <router-view slot="body"/>
        </GZ-Content>
        <GZ-Footer/>
    </div>
</template>

<script>
export default {
    name: 'GuestLayout'
}
</script>